import { TOKEN_INFOS_CACHE_KEY, tokenInfosCache } from "@/utils/cache/api-cache.util"
import { getCDNTokenList } from "@/utils/helpers"
import { WHITELIST_TOKEN_INFO_SYMBOLS } from "../whitelists"

let fetchAllTokenInfosTimeout: NodeJS.Timeout | null = null

const fetchAllTokenInfos = async () => {
  try {
    const cdnTokenList = await getCDNTokenList()
    const tokenInfoToSet = cdnTokenList?.tokens.filter((t) => WHITELIST_TOKEN_INFO_SYMBOLS.includes(t.symbol)) || []
    tokenInfosCache.set(TOKEN_INFOS_CACHE_KEY, tokenInfoToSet)
    return tokenInfoToSet
  } catch (error) {
    console.error("Failed to fetch token infos:", error)
  } finally {
    if (fetchAllTokenInfosTimeout) {
      clearTimeout(fetchAllTokenInfosTimeout)
    }
    fetchAllTokenInfosTimeout = setTimeout(fetchAllTokenInfos, 60 * 1000)
  }
}

const fetchNecessaryTokenInfos = async () => {
  let tokenInfos = tokenInfosCache.get(TOKEN_INFOS_CACHE_KEY)

  if (!tokenInfos) {
    const tokenInfosToSet = await fetchAllTokenInfos()
    tokenInfos = tokenInfosToSet
  }

  return tokenInfos
}

export default fetchNecessaryTokenInfos
